export interface LocalizedText {
    en: string;
    ar: string;
}

export interface GalleryItem {
    id: string;
    type: "image" | "video";
    src: string;
    thumbnail?: string;
    title?: LocalizedText;
    category: string;
    beforeSrc?: string;
}

export interface VideoItem {
    id: string;
    src: string;
    thumbnail: string;
    title: LocalizedText;
    description: LocalizedText;
    category: "clinical" | "testimonial" | "clinic-tour";
    duration?: string;
}

export const galleryCategories: Record<string, LocalizedText> = {
    cases: { en: "Clinical Cases", ar: "حالات إكلينيكية" },
    pediatric: { en: "Pediatric Dentistry", ar: "طب أسنان الأطفال" },
    reviews: { en: "Patient Reviews", ar: "آراء المرضى" },
    team: { en: "Our Team", ar: "فريقنا" },
    videos: { en: "Video Showcase", ar: "معرض الفيديو" }
};

export const galleryItems: GalleryItem[] = [
    // Team Members (First)
    {
        id: "team-new-1",
        type: "image",
        src: "/images/gallery/team/WhatsApp Image 2026-03-07 at 2.07.14 AM.webp",
        title: { en: "Our Specialized Doctors", ar: "أطباؤنا المتخصصون" },
        category: "team"
    },
    {
        id: "team-new-2",
        type: "image",
        src: "/images/gallery/team/WhatsApp Image 2026-03-07 at 2.08.21 AM.webp",
        title: { en: "Primero Clinical Team", ar: "فريق بريميرو الطبي" },
        category: "team"
    },
    {
        id: "team-new-3",
        type: "image",
        src: "/images/gallery/team/WhatsApp Image 2026-03-07 at 2.08.22 AM.webp",
        title: { en: "Professional Staff", ar: "طاقم عمل محترف" },
        category: "team"
    },
    {
        id: "team-new-4",
        type: "image",
        src: "/images/gallery/team/WhatsApp Image 2026-03-07 at 2.08.21 AM (1).webp",
        title: { en: "Dental Experts", ar: "خبراء طب الأسنان" },
        category: "team"
    },

    // Pediatric (from Kids Cases)
    {
        id: "pedia-2",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 6.54.53 PM.webp",
        title: { en: "Happy Little Patient", ar: "مريضنا الصغير السعيد" },
        category: "pediatric"
    },
    {
        id: "pedia-3",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 6.54.54 PM.webp",
        title: { en: "Smile Design for Kids", ar: "تصميم ابتسامة للأطفال" },
        category: "pediatric"
    },
    {
        id: "pedia-4",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 6.54.55 PM.webp",
        title: { en: "Gentle Dental Treatment", ar: "علاج أسنان بلطف" },
        category: "pediatric"
    },
    {
        id: "pedia-5",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 6.54.56 PM.webp",
        title: { en: "Modern Pediatric Care", ar: "رعاية حديثة لأسنان الأطفال" },
        category: "pediatric"
    },
    {
        id: "pedia-6",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 7.02.46 PM.webp",
        title: { en: "Comfortable Environment", ar: "بيئة مريحة" },
        category: "pediatric"
    },
    {
        id: "pedia-7",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-06 at 7.56.18 PM.webp",
        title: { en: "Kids Dental Education", ar: "توعية طبية للأطفال" },
        category: "pediatric"
    },
    {
        id: "pedia-8",
        type: "image",
        src: "/images/gallery/pediatric/WhatsApp Image 2026-03-07 at 2.07.14 AM (1).webp",
        title: { en: "Comprehensive Pediatric Checkup", ar: "فحص شامل لأسنان الأطفال" },
        category: "pediatric"
    },

    // Clinical Cases (from public/images/gallery)
    {
        id: "case-smile-1",
        type: "image",
        src: "/images/gallery/smile-1.webp",
        title: { en: "Smile Design Makeover", ar: "تجديد كامل للابتسامة" },
        category: "cases"
    },
    {
        id: "case-smile-2",
        type: "image",
        src: "/images/gallery/smile-2.webp",
        title: { en: "Aesthetic Restoration", ar: "ترميم تجميلي" },
        category: "cases"
    },
    {
        id: "case-smile-3",
        type: "image",
        src: "/images/gallery/smile-3.webp",
        title: { en: "Digital Smile Planning", ar: "تخطيط رقمي للابتسامة" },
        category: "cases"
    },
    {
        id: "case-smile-4",
        type: "image",
        src: "/images/gallery/smile-4.webp",
        title: { en: "Complete Transformation", ar: "تحول كامل" },
        category: "cases"
    },
    {
        id: "case-smile-5",
        type: "image",
        src: "/images/gallery/smile-5.webp",
        title: { en: "Porcelain Veneers", ar: "فينير خزفي" },
        category: "cases"
    },
    {
        id: "case-smile-6",
        type: "image",
        src: "/images/gallery/smile-6.webp",
        title: { en: "Natural Looking Results", ar: "نتائج بمظهر طبيعي" },
        category: "cases"
    },
    {
        id: "case-smile-7",
        type: "image",
        src: "/images/gallery/smile-7.webp",
        title: { en: "Cosmetic Dentistry", ar: "تجميل الأسنان" },
        category: "cases"
    },
    {
        id: "case-smile-8",
        type: "image",
        src: "/images/gallery/smile-8.webp",
        title: { en: "Hollywood Smile", ar: "ابتسامة هوليود" },
        category: "cases"
    },
    {
        id: "case-smile-9",
        type: "image",
        src: "/images/gallery/smile-9.webp",
        title: { en: "Perfect White Smile", ar: "ابتسامة بيضاء مثالية" },
        category: "cases"
    },
    {
        id: "case-smile-10",
        type: "image",
        src: "/images/gallery/smile-10.webp",
        title: { en: "Flawless Teeth Alignment", ar: "تسوية أسنان مثالية" },
        category: "cases"
    },
    {
        id: "case-ortho-1",
        type: "image",
        src: "/images/gallery/before-after-ortho.webp",
        title: { en: "Orthodontic Results Before & After", ar: "نتائج تقويم الأسنان قبل وبعد" },
        category: "cases"
    }
];

// YouTube video IDs mapped from the original V1-V9 local files
export const videoGalleryItems: VideoItem[] = [
    {
        id: "v-new-1",
        src: "ZTdoiiKWdBU",
        thumbnail: "ZTdoiiKWdBU",
        title: { en: "3D Smile Design & Planning", ar: "تصميم وتخطيط الابتسامة ثلاثي الأبعاد" },
        description: { en: "Experience the precision of digital planning for your perfect smile.", ar: "اختبر دقة التخطيط الرقمي لابتسامتك المثالية." },
        category: "clinical"
    },
    {
        id: "v-new-2",
        src: "kp9GTWbZPpk",
        thumbnail: "kp9GTWbZPpk",
        title: { en: "Professional Consultation", ar: "استشارة احترافية" },
        description: { en: "Join our expert team for a personalized dental consultation.", ar: "انضم إلى فريقنا الخبير للحصول على استشارة أسنان مخصصة." },
        category: "clinical"
    },
    {
        id: "v-new-3",
        src: "EUbBsNsCUR8",
        thumbnail: "EUbBsNsCUR8",
        title: { en: "Advanced Clinical Case", ar: "حالة إكلينيكية متقدمة" },
        description: { en: "Detailed walkthrough of a complex clinical procedure.", ar: "شرح تفصيلي لإجراء إكلينيكي معقد." },
        category: "clinical"
    },
    {
        id: "v-new-4",
        src: "OvpGJ-WuVI8",
        thumbnail: "OvpGJ-WuVI8",
        title: { en: "Modern Clinic Tour", ar: "جولة في العيادة الحديثة" },
        description: { en: "Take a virtual tour of our high-standard sterilization and patient care areas.", ar: "قم بجولة افتراضية في مناطق التعقيم ورعاية المرضى عالية المستوى لدينا." },
        category: "clinic-tour"
    },
    {
        id: "v-new-5",
        src: "3gnUtxslFLw",
        thumbnail: "3gnUtxslFLw",
        title: { en: "Advanced Pediatric Care", ar: "رعاية متقدمة لأسنان الأطفال" },
        description: { en: "A gentle and fun approach to children's dentistry.", ar: "أسلوب لطيف وممتع في طب أسنان الأطفال." },
        category: "clinical"
    },
    {
        id: "v-new-6",
        src: "qG5L0xmYVeE",
        thumbnail: "qG5L0xmYVeE",
        title: { en: "Precision Technology", ar: "تكنولوجيا الدقة" },
        description: { en: "Using the latest digital tools for accurate diagnosis.", ar: "استخدام أحدث الأدوات الرقمية لتشخيص دقيق." },
        category: "clinical"
    },
    {
        id: "v-new-7",
        src: "JUzs4ftwb6k",
        thumbnail: "JUzs4ftwb6k",
        title: { en: "Patient Experience", ar: "تجربة المريض" },
        description: { en: "See why our patients trust us with their dental health.", ar: "شاهد لماذا يثق مرضانا بنا في صحة أسنانهم." },
        category: "testimonial"
    },
    {
        id: "v-new-8",
        src: "gpcksF3TTuY",
        thumbnail: "gpcksF3TTuY",
        title: { en: "Smile Transformation", ar: "تحول الابتسامة" },
        description: { en: "Before and after results showcase of our smile makeovers.", ar: "عرض نتائج قبل وبعد لتجديد الابتسامات لدينا." },
        category: "clinical"
    },
    {
        id: "v-new-9",
        src: "3gnUtxslFLw",
        thumbnail: "3gnUtxslFLw",
        title: { en: "Sterilization Standards", ar: "معايير التعقيم" },
        description: { en: "Our commitment to hygiene and patient safety.", ar: "التزامنا بالنظافة وسلامة المرضى." },
        category: "clinic-tour"
    }
];
